import { BoxVariableNames } from './variables/box';
import { ButtonVariableNames } from './variables/button';
import { ColorVariableNames } from './variables/color';
import { LineVariableNames } from './variables/line';
import { TextVariableNames } from './variables/text';
export const WixThemeVariableNames = {
  ...ColorVariableNames,
  ...TextVariableNames,
  ...ButtonVariableNames,
  ...BoxVariableNames,
  ...LineVariableNames
};
//# sourceMappingURL=wix-theme-variable.js.map